export default __webpack_public_path__ + "static/media/product8.81b3d84d.jpg";